import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {ConversationHeaderPill} from '../../../../../components/inboxes/viewer/conversation/header/conversationHeaderPill';
import {ConversationHeaderTagPillContent} from '../../../../../components/inboxes/viewer/conversation/header/tag/conversationHeaderTagPillContent';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {getColorHighlight} from '../../../../../helpers/models/highlightHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {getUser} from '../../../../../store/data/teammates/teammatesSelectors';

/*
 * Props.
 */

interface ConversationCardTagProps {
  tag: TagModel;
}

/*
 * Component.
 */

export const ConversationCardTag: FC<ConversationCardTagProps> = ({tag}) => {
  const user = useAppSelector(getUser);

  if (tag.isMainInboxTag) {
    return (
      <ConversationHeaderPill
        size={VisualSizesEnum.SMALL}
        isPrivate
        renderIcon={() => <Icon name="inboxFilledSmall" />}
      >
        <Trans id="tags-inboxtag">Inbox</Trans>
      </ConversationHeaderPill>
    );
  }

  const color = getColorHighlight(tag);
  const isPrivate = tag.namespace === user.namespace;

  // Normal case for any other tag.
  return (
    <ConversationHeaderPill size={VisualSizesEnum.SMALL} color={color} isPrivate={isPrivate}>
      <ConversationHeaderTagPillContent size={VisualSizesEnum.SMALL} tagsPath={[tag]} />
    </ConversationHeaderPill>
  );
};
